module.exports = __webpack_public_path__ + "static/media/Piercing-ear-daith.a815c958.png";